import React from 'react';
import { motion } from 'framer-motion';
import { HardHat, Briefcase, Eye } from 'lucide-react';
export function PersonasSection() {
  const personas = [{
    role: 'Para el constructor',
    icon: <HardHat className="w-8 h-8 text-blue-600" data-id="element-185" />,
    text: 'Subes el chat al final del día. La app arma el reporte semanal automático. Cuando el mandante pregunta, abres la plataforma y le muestras en 30 segundos.'
  }, {
    role: 'Para el mandante',
    icon: <Briefcase className="w-8 h-8 text-blue-600" data-id="element-186" />,
    text: 'Recibes un PDF semanal con avances, decisiones y problemas. Sin tener que pedirlo. Si quieres más detalle, entras a la plataforma.'
  }, {
    role: 'Para el ITO',
    icon: <Eye className="w-8 h-8 text-blue-600" data-id="element-187" />,
    text: "Acceso 24/7 a todas tus obras. Filtras por 'problema' y ves todo lo pendiente. Llegas a la reunión leído."
  }];
  return <section className="py-14 sm:py-20 bg-gray-50 border-t border-gray-200" data-id="element-188">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-189">
        <div className="text-center mb-12 sm:mb-16" data-id="element-190">
          <h2 className="text-3xl sm:text-4xl font-extrabold text-gray-900" data-id="element-191">
            Lo que ve cada persona
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-192">
          {personas.map((persona, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.15
        }} className="bg-white rounded-2xl p-8 shadow-sm border border-gray-200 flex flex-col items-center text-center" data-id="element-193">
              <div className="w-16 h-16 bg-blue-50 rounded-2xl flex items-center justify-center mb-6" data-id="element-194">
                {persona.icon}
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-195">
                {persona.role}
              </h3>
              <p className="text-base text-gray-600 leading-relaxed" data-id="element-196">
                {persona.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}